import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.request-center.approve', {
        url: '/:requestId/approve',
        component: 'approveAccessRequest',
        resolve: {accounts, accessRequest},
    })
}

/** @ngInject */
function accounts(UsersResource, $stateParams, accessRequest){
    return UsersResource.getAllAccountsForCompanyUser($stateParams.companyId, accessRequest.companyUser.id);
}

/** @ngInject */
function accessRequest($stateParams, requests) {
    return requests.find(req => req.id === $stateParams.requestId);
}


// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/approve/approve-access-request.state.js